import { render, staticRenderFns } from "./SortSwitch_project_open.vue?vue&type=template&id=3286be60&"
import script from "./SortSwitch_project_open.vue?vue&type=script&lang=js&"
export * from "./SortSwitch_project_open.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports